module.exports = __webpack_public_path__ + "static/media/Watermark_IDCard.b10f6c78.png";